module.exports = __webpack_public_path__ + "img/suijin-chart-pole.c5186cf6.png";